import { render, staticRenderFns } from "./ProcessWorkPermitSJ.vue?vue&type=template&id=12f4affc"
import script from "./js/ProcessWorkPermitSJ.js?vue&type=script&lang=js&external"
export * from "./js/ProcessWorkPermitSJ.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports